// @flow

import React, { type ComponentType } from 'react';
import { withErrorEmptyComponent } from '../emptyComponent';
import { getComponentMapping, type ComponentMap } from '../../context/componentMapping';
import type { ACFComponent as ACFComponentType } from '../../types';

type Props = {|
  component: ?ACFComponentType,
  componentMapping: ComponentMap,
  noBox?: boolean, // eslint-disable-line react/require-default-props
|};

const ACFComponent: ComponentType<Props> = ({
  component,
  componentMapping,
  ...rest
}) => {
  if (!component) {
    return null;
  }

  // Get React component or fallback to EmptyComponent if there is no match
  const EmptyComponent = withErrorEmptyComponent(`Couldn't map ${component.acf_fc_layout} to a component in ACFComponent`);
  const Component = componentMapping[component.acf_fc_layout] || EmptyComponent;

  return (
    <Component
      {...component}
      {...rest}
    />
  );
};

export default getComponentMapping(ACFComponent);
